import { useReducer } from 'react';
import {
    type InventoryFilteringRule,
    InventorySortingField,
    type InventorySortingRule,
    SortingOrder,
} from '../../../../api/types';
import {
    type ExtendedPageState,
    type ExtendedPageAction,
    extendedReducer,
} from '../../../../components/PaginatedTableWithContext';
import { TableSortingOrder, type SortOrderValue } from '../../../../utilities/useSortAndFilterCache';

type SortRule = InventorySortingRule & SortOrderValue;
type State = ExtendedPageState & {
    sort: SortRule;
    filter: InventoryFilteringRule;
};

export type SetSortAction = { type: 'setSort'; sortBy: SortRule };

export type SetFilterAction = { type: 'setFilter'; filterBy: InventoryFilteringRule };

export type Action = ExtendedPageAction | SetSortAction | SetFilterAction;

const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case 'setPage':
            return { ...state, page: action.page };

        case 'setPageSize':
            return { ...state, page: 0, pageSize: action.pageSize };

        case 'setSort':
            return { ...state, page: 1, sort: action.sortBy };

        case 'setFilter':
            return { ...state, page: 1, filter: action.filterBy };

        default:
            return extendedReducer(state, action);
    }
};

const useListReducer = (cache?: State) =>
    useReducer(reducer, {
        companyId: cache?.companyId,
        // default pagination
        page: cache?.page || 1,
        pageSize: cache?.pageSize || 10,

        // default sorting
        sort: cache?.sort || {
            field: InventorySortingField.Id,
            order: SortingOrder.Asc,
            orderValue: TableSortingOrder.Desc,
        },

        filter: cache?.filter || {},
    });

export default useListReducer;
